module.exports = __webpack_public_path__ + "img/ssa1.76db456c.jpg";